import { Grid, Progress, Text } from '@mantine/core';
import { AssetRowDescriptor } from '../hooks/useAssetsTable';
import { usePendingOutputsConsumer } from '../hooks/usePendingOutputs';
import { ASSET_COLUMNS_SPAN } from '../hooks/useColumns';

import styles from './styles.module.css';

const getRowDescriptior = (id: string) => {
  try {
    const assetDescriptor = JSON.parse(id) as AssetRowDescriptor;
    return assetDescriptor.id;
  } catch (error) {
    return null;
  }
};

export const AssetProgress = ({ id }: { id: string }) => {
  const assetId = getRowDescriptior(id);
  const { getAssetProgress } = usePendingOutputsConsumer();

  if (!assetId) {
    return null;
  }

  const assetProgress = getAssetProgress(assetId);

  if (!assetProgress) {
    return null;
  }

  const { progress, operationsInProgress, operationsCount } = assetProgress;

  return (
    <Grid pl='6' pt={15} h={41} columns={ASSET_COLUMNS_SPAN} align='flex-end'>
      <Grid.Col span={3} p={0}></Grid.Col>
      <Grid.Col span={ASSET_COLUMNS_SPAN - 14} p='auto' h={21}>
        <Progress color='teal.7' value={progress} animated={true} className={progress === 0 ? styles.progress : ''} />
      </Grid.Col>
      <Grid.Col span={11} p='0' h={21} pl='sm'>
        <Text size='md' c='gray.6' h={21}>{`Processing (${operationsInProgress} out of ${operationsCount})`}</Text>
      </Grid.Col>
    </Grid>
  );
};
